import React from 'react';
import { Button } from './ui/button';
import { AlertCircle, RefreshCw } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const ErrorMessage = ({ 
  error, 
  onRetry, 
  showRetry = true,
  className = "p-8 text-center"
}) => {
  const { language } = useLanguage();

  const messages = {
    en: {
      title: 'Something went wrong',
      retry: 'Try Again',
      defaultError: 'An unexpected error occurred. Please try again.'
    },
    es: {
      title: 'Algo salió mal',
      retry: 'Intentar de Nuevo',
      defaultError: 'Ocurrió un error inesperado. Por favor intenta de nuevo.'
    }
  };

  const content = messages[language];
  const errorMessage = error?.message || content.defaultError;

  return (
    <div className={className}>
      <div className="max-w-md mx-auto">
        <AlertCircle className="w-12 h-12 text-red-500 mx-auto mb-4" />
        <h3 className="text-lg font-semibold text-gray-800 mb-2">
          {content.title}
        </h3>
        <p className="text-gray-600 mb-6">
          {errorMessage}
        </p>
        {showRetry && onRetry && (
          <Button 
            onClick={onRetry}
            variant="outline"
            className="flex items-center space-x-2 mx-auto"
          >
            <RefreshCw className="w-4 h-4" />
            <span>{content.retry}</span>
          </Button>
        )}
      </div>
    </div>
  );
};

export default ErrorMessage;